import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { EmailCampaignFromWorkflowAIResponse } from './types/responses';

type GetEmailCampaignFromWorkflowAIParams = {
  artistId: string;
  contentId: string;
  locale: string;
};

export async function getEmailCampaignFromWorkflowAI({
  artistId,
  contentId,
  locale,
}: GetEmailCampaignFromWorkflowAIParams) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Announcement ID is required');
  if (!locale) throw Error('Locale is required');

  const url = `web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/email`;
  const response = await api.executeGetRequest<ObjectResponse<EmailCampaignFromWorkflowAIResponse>>(url);

  return response.data;
}
